import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import GoogleReviews from "../components/GoogleReviews";
import TouristSlider from "../components/TouristSlider";
import CartFloatingButton from "../components/CartFloatingButton";
import "./Home.css";

function Home() {
  const navigate = useNavigate();
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);

  // Restrict bookings to a 3-month window from today
  const maxBookingDate = new Date();
  maxBookingDate.setMonth(maxBookingDate.getMonth() + 3);

  useEffect(() => {
    const items = document.querySelectorAll(".reveal");
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("active");
          }
        });
      },
      { threshold: 0.15 }
    );

    items.forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleStartDateChange = (date) => {
    setStartDate(date);
    // If the current end date is now before or equal to the new start, clear it
    if (endDate && date && endDate <= date) {
      setEndDate(null);
    }
  };

  const isToday = (date) => {
    const today = new Date();

    return (
      date &&
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const getMinTime = (date) => {
    if (!isToday(date)) {
      return new Date(0, 0, 0, 0, 0);
    }

    return new Date();
  };
  const handleSearch = () => {
    if (!startDate || !endDate) {
      toast.warning("Please select pickup and drop time");
      return;
    }

    if (endDate <= startDate) {
      toast.error("Drop-off date must be after pickup date");
      return;
    }

    navigate(
      `/available-bikes?start=${startDate.toISOString()}&end=${endDate.toISOString()}`
    );
  };

  return (
    <>
      <CartFloatingButton />

      {/* ================= HERO ================= */}
      <section
        className="hero hero-with-image"
        style={{
          backgroundImage: `url(${process.env.PUBLIC_URL}/hero/hero-bike.png)`
        }}
      >
        <div className="hero-bg-gradient"></div>

        <div className="hero-content reveal">
          <h1>
            Find Your <span>Perfect Ride</span>
          </h1>

          <p className="hero-tagline">
            Rent bikes anytime, anywhere.
          </p>

          <div className="search-bar">
            <div className="date-picker-wrapper">
              <DatePicker
                selected={startDate}
                onChange={handleStartDateChange}
                popperPlacement="bottom-start"
                showTimeSelect
                dateFormat="Pp"
                placeholderText="Pickup date & time"
                className="input"
                minDate={new Date()}
                maxDate={maxBookingDate}
                minTime={getMinTime(startDate)}
                maxTime={new Date(0, 0, 0, 23, 59)}
              />
            </div>

            <div className="date-picker-wrapper">
              <DatePicker
                selected={endDate}
                onChange={(date) => setEndDate(date)}
                popperPlacement="bottom-start"
                showTimeSelect
                dateFormat="Pp"
                placeholderText="Drop date & time"
                className="input"
                minDate={startDate || new Date()}
                maxDate={maxBookingDate}
                minTime={getMinTime(endDate)}
                maxTime={new Date(0, 0, 0, 23, 59)}
              />
            </div>

            <button onClick={handleSearch}>
              Search Bikes
            </button>
          </div>

          <div className="trust-text">
            ✓ 1000+ happy riders • ✓ No hidden charges
          </div>
        </div>
      </section>

      {/* ================= TOURIST PLACES SLIDER ================= */}
      <TouristSlider />

      {/* ================= FEATURES ================= */}
      <section className="features">
        <div className="features-header reveal">
          <h2>
            Why Choose <span>BRO'S RENTAL</span>
          </h2>
          <p>Everything you need for a smooth and reliable ride</p>
        </div>

        <div className="features-grid">
          <div className="feature reveal">
            <h3>Affordable Pricing</h3>
            <p>Only pay for what you ride. No deposits. Easy to Use and Affordable Pricing</p>
          </div>
          <div className="feature reveal">
            <h3>No Security Deposit</h3>
            <p>Enjoy the freedom of riding without upfront security deposits. Only pay for what you ride.</p>
          </div>
          <div className="feature reveal">
            <h3>24/7 Support</h3>
            <p>Customer Support is available 24/7. Ready to assist you with any questions or concerns you may have</p>
          </div>
        </div>
      </section>



      {/* ================= TOP RATED BIKES (READY) ================= */}
      {/* 
        Example usage when you add Top Rated Bikes data:

        <StarRating rating={b.avgRating} size={18} />
        <p style={{ fontWeight: "bold" }}>
          {b.avgRating.toFixed(1)} ({b.totalReviews} reviews)
        </p>
      */}

      {/* ================= REVIEWS LIST (READY) ================= */}
      {/* 
        Example usage wherever reviews are shown:

        <StarRating rating={r.rating} size={14} />
        <p>{r.comment}</p>
      */}

      {/* ================= GOOGLE REVIEWS ================= */}
      <GoogleReviews />
    </>
  );
}

export default Home;
